export default __webpack_public_path__ + "static/media/order-bell-brownIcon.98498499.svg";